export interface CardProps {
  variant?: CardVariantType
  spacing?: CardSpacingType
  children: React.ReactNode
  className?: string
}

export enum CardVariant {
  outlined = 'outlined',
  elevated = 'elevated',
}

export enum CardSpacing {
  compact = 'compact',
  wide = 'wide',
}

export type CardVariantType = `${CardVariant}`
export type CardSpacingType = `${CardSpacing}`
